<script setup lang="ts">
import type { ColumnFiltersState } from '@tanstack/vue-table'
import type { GetUserPromptMode } from '~~/src/api/users'
import { useProfileFeed } from '~~/src/composables/query/useProfileFeed'
import type { ElementalTypeEnum } from '~~/src/types/elemental'
import { resolveValueByPath } from '~~/src/utils/resolve-value-by-path'
const props = defineProps<{
  mode?: GetUserPromptMode
  type: ElementalTypeEnum
  filters?: ColumnFiltersState
}>()
defineOptions({ name: 'ListLoader' })

const { firebaseUser } = useFirebaseAuth()
const { data, refetch, isLoading, error, isError } = useProfileFeed(firebaseUser.value?.uid as string, {
  mode: props.mode || 'saved',
  order_by: 'name',
  elemental_type_id: props.type,
  size: 0,
  is_knowledge_base: false,
}, {
  enabled: computed(() => !!firebaseUser.value?.uid),
})

const filteredData = computed(() => {
  const res = data.value?.map((item: any) => {
    if (item.id === 'all') {
      const filteredPrompts = item.prompts?.filter((prompt: any) => {
        return props.filters?.every((filter) => {
          const itemValue = resolveValueByPath(prompt, filter.id)
          return itemValue?.toString() === filter.value?.toString()
        })
      }) || []

      if (filteredPrompts.length === 0)
        return null

      return {
        ...item,
        prompts: filteredPrompts,
      }
    }

    const matches = props.filters?.every((filter) => {
      const itemValue = resolveValueByPath(item, filter.id)
      return itemValue?.toString() === filter.value?.toString()
    })

    return matches ? item : null
  }).filter(Boolean) || []
  return res
})
</script>

<template>
  <slot :lists="filteredData" :error="error" :is-error="isError" :is-loading="isLoading" :refetch="refetch" />
</template>
